<template>
  <section class="newsletter" :class="{ 'is-webp': isWebpSupported }">
    <div class="main-container">
      <div class="grid">
        <div class="col-6_lg-8_sm-12">
          <div class="newsletter__content">
            <h2 class="newsletter__header js-reveal">
              Want to follow your beans?<br />We’ll keep you posted.
            </h2>
            <p class="newsletter__text js-reveal">
              Subscribe to our newsletter below:
            </p>
            <form
              id="newsletter-form"
              class="newsletter__form js-reveal"
              @submit.prevent.stop="makeSubscription"
            >
              <!-- handled in main.js -->
              <input
                v-model="email"
                name="email"
                type="email"
                placeholder="yourname@email.com..."
                class="newsletter__form-input"
                required
              />
              <button
                type="submit"
                class="newsletter__form-button butn butn--sm butn--red"
                :class="{ loading: loading }"
              >
                <span class="spin"></span>
                <span class="text">SUBSCRIBE</span>
              </button>
            </form>
            <div
              class="newsletter__sub-text"
              :class="{ 'hide--visible': !subscribed && !error }"
            >
              <template v-if="subscribed">
                <i class="green iconmoon-thick"></i>
                "Done! You are now subscribed."
              </template>
              <template v-else-if="error && error.subscribe">
                <i class="red iconmoon-no"></i>
                "This email is already subscribed."
              </template>
              <template v-else-if="error && error.email">
                <i class="red iconmoon-no"></i>
                "Please provide valid email."
              </template>
            </div>
          </div>
        </div>
        <div class="col-6_lg-4 md-hidden">
          <div ref="image" class="newsletter__img"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { subscribe } from "../../../services/subscription";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      email: null,
      subscribed: false,
      error: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters("settings", {
      isWebpSupported: "isWebpSupported"
    })
  },
  methods: {
    makeSubscription() {
      this.loading = true;
      subscribe(this.email)
        .then(() => {
          this.error = null;
          this.subscribed = true;
          this.loading = false;
        })
        .catch(error => {
          this.error = {};
          this.subscribed = false;
          this.loading = false;
          if (error.response.data.api_code === "minidayz.alreadySubscribed") {
            this.error.subscribe = true;
          } else {
            this.error.email = true;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../../assets/styles/vars";
@import "../../../assets/styles/mixins";
.newsletter {
  .newsletter__img {
    display: block;
    width: 34.57143em;
    height: 36.35714em;
    background-image: url("../../../assets/img/newsletter-icon.png");
    background-size: contain;
    margin: -1.75em auto 0;
    @media (max-width: $screen-xl) {
      margin-top: -7.5em;
    }
    @media (max-width: $screen-md-down) {
      background-image: none !important;
    }
  }
  font-size: 1rem;
  background: url("../../../assets/img/bg/bg-newsletter.jpg") center bottom
    no-repeat;

  @media (max-width: $screen-xl-min) {
    font-size: 0.8rem;
    background-image: url("../../../assets/img/bg/bg-newsletter.jpg?size=1920");
  }

  @media (max-width: $screen-lg-min) {
    font-size: 0.75rem;
    background-image: url("../../../assets/img/bg/bg-newsletter.jpg?size=1280");
  }

  @media (max-width: $screen-md-down) {
    background-image: url("../../../assets/img/bg/bg-newsletter.jpg?size=1024");
    font-size: 0.65rem;
  }

  @media (max-width: $screen-sm-down) {
    background-image: url("../../../assets/img/bg/bg-newsletter.jpg?size=768");
  }

  @media (max-width: $screen-xs-down) {
    font-size: 0.5rem;
    background-image: url("../../../assets/img/bg/bg-newsletter.jpg?size=360");
  }

  [class*="col-"] {
    padding-bottom: 0;
  }

  &.is-webp {
    background: url("../../../assets/img/bg/bg-newsletter.webp") center bottom
      no-repeat;
    @media (max-width: $screen-xl-min) {
      background-image: url("../../../assets/img/bg/bg-newsletter.webp?size=1920");
    }
    @media (max-width: $screen-lg-min) {
      background-image: url("../../../assets/img/bg/bg-newsletter.webp?size=1280");
    }
    @media (max-width: $screen-md-down) {
      background-image: url("../../../assets/img/bg/bg-newsletter.webp?size=1024");
    }
    @media (max-width: $screen-sm-down) {
      background-image: url("../../../assets/img/bg/bg-newsletter.webp?size=768");
    }
    @media (max-width: $screen-xs-down) {
      background-image: url("../../../assets/img/bg/bg-newsletter.webp?size=360");
    }
  }
}

.newsletter__form-button {
  position: relative;

  .spin {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 1em;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.8em;
    transition: opacity 0.2s ease-in-out;
  }

  .text {
    display: inline-block;
    transition: transform 0.2s ease-in-out;
  }

  &.loading {
    .spin {
      visibility: visible;
      opacity: 1;
    }

    .text {
      transform: translateX(5px);
    }
  }
}

.spin {
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 1px solid;
  border-radius: 50%;
  border-right-color: transparent;
  animation: 0.5s linear infinite rotate;
}

@keyframes rotate {
  from {
    transform: translateY(-50%) rotate(0);
  }

  to {
    transform: translateY(-50%) rotate(360deg);
  }
}
</style>
